module.exports = __webpack_public_path__ + "media/app/assets/covenants/venthyr-e19cb6bb5514397f5d30d7636078acc7.png";